'use client';

import { usePathname, useRouter } from 'next/navigation';
import React, { useEffect } from 'react';

/**
 * Allys-themed wrapper for the Royale Spaces Wizard.
 *
 * The standalone wizard was removed in favour of the portal-integrated
 * Room Designer at /account/spaces. This component redirects there so
 * any existing page that renders <AllysSpacesWizard /> still works.
 */
export const AllysSpacesWizard: React.FC = () => {
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    const match = pathname.match(/^\/([a-z]{2})(\/|$)/);
    const locale = match?.[1] ?? 'en';
    router.replace(`/${locale}/account/spaces`);
  }, [router, pathname]);

  return null;
};
